import log from 'loglevel'
import axios, { type AxiosHeaders } from 'axios'
import { isNil } from 'lodash/fp'

import { url, getCustomHeaders } from 'components/DataProvider/functions'
import { assign } from 'lodash'
import { type Partner } from '@mzc-watchover/adminapp-appsync'

log.setLevel(log.levels.DEBUG)

export const doUpload = async (
  file: string,
  partner: Partial<Partner> | undefined,
  noStop: boolean
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const customHeaders = getCustomHeaders(
    {},
    !isNil(partner) ? partner.id : undefined
  ) as AxiosHeaders | undefined
  if (isNil(customHeaders)) return undefined
  const headers = {
    Authorization: customHeaders.get('Authorization')
  }
  if (!isNil(partner)) {
    assign(headers, { 'X-Partner': partner.id })
  }
  const { status } = await axios.post(
    `${url}/users`,
    { file, noStop },
    {
      headers
    }
  )
  return status
}
export const doCognitoUpload = async (
  file: string
): Promise<number | undefined> => {
  if (isNil(url)) return undefined
  const headers = getCustomHeaders({}, undefined) as AxiosHeaders | undefined
  if (isNil(headers)) return undefined
  const { status } = await axios.post(
    `${url}/cognito/users`,
    { file },
    {
      headers: { Authorization: headers.get('Authorization') }
    }
  )
  return status
}
